export { default } from "../../../../../../lib/Plans/getCurrencyOfferByPeriod";
